import * as protocolo from './protocolo';
import { crearError } from './utilidades';

export interface ErrorHttp extends Error {
    codigo: number;
}
export const ErrorHttp = crearError('ErrorHttp', function(
    this: ErrorHttp,
    codigo: number,
    mensaje: string,
) {
    this.codigo = codigo;
    this.message = mensaje;
});

export interface ErrorTipoRespuesta extends Error {
    mensaje: string;
    detalles: ReadonlyArray<string>;
}
export const ErrorTipoRespuesta = crearError('ErrorTipoRespuesta', function(
    this: ErrorTipoRespuesta,
    mensaje: string,
    detalles: ReadonlyArray<string>,
) {
    this.mensaje = this.message = mensaje;
    this.detalles = detalles;
});

export interface ErrorApi extends Error {
    comando: string;
    tipo: string;
    mensaje: string;
    detalles: ReadonlyArray<string>;
}
export const ErrorApi = crearError('ErrorApi', function(
    this: ErrorApi,
    comando: string,
    tipo: protocolo.RespuestaFallida['error']['tipo'],
    mensaje: string,
    detalles: ReadonlyArray<string>,
) {
    this.comando = comando;
    this.tipo = tipo;
    this.message = this.mensaje = mensaje;
    this.detalles = detalles;
});



// WEBPACK FOOTER //
// ./src/api/clienteApi/errores.ts